import { type ComponentType } from 'react';
import { TitleSlide } from './components/slides/TitleSlide';
import { PremiseSlide } from './components/slides/PremiseSlide';
import { FrameworkSlide } from './components/slides/FrameworkSlide';
import { CriteriaSlide } from './components/slides/CriteriaSlide';
import { HcpPerceptionSlide } from './components/slides/HcpPerceptionSlide';
import { LeoFactsSlide } from './components/slides/LeoFactsSlide';
import { WarfareSlide } from './components/slides/WarfareSlide';
import { GapSlide } from './components/slides/GapSlide';
import { ThankYouSlide } from './components/slides/ThankYouSlide';
export type DeckSlide = {
  id: string;
  title: string;
  component: ComponentType;
};
export const slides: DeckSlide[] = [{
  id: 'scr_gy9b2a',
  title: 'Mind the gap',
  component: TitleSlide
}, {
  id: 'scr_pr3m1s',
  title: 'The strategy lives in the gap',
  component: PremiseSlide
}, {
  id: 'scr_fr4m3w',
  title: 'Four steps in, two routes — usually both',
  component: FrameworkSlide
}, {
  id: 'scr_cr1t3r',
  title: 'What decides the script',
  component: CriteriaSlide
}, {
  id: 'scr_hcpp3r',
  title: 'How HCPs rate the options today',
  component: HcpPerceptionSlide
}, {
  id: 'scr_l3ofct',
  title: 'What Roche holds to be true',
  component: LeoFactsSlide
}, {
  id: 'scr_w4rf4r',
  title: 'Warfare — prescription criteria',
  component: WarfareSlide
}, {
  id: 'scr_g4pqnt',
  title: 'The gap, quantified',
  component: GapSlide
}, {
  id: 'scr_2r0ut3',
  title: 'Thank you',
  component: ThankYouSlide
}];